import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block3-资讯中心.png")